import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import ShipmentForm from "components/Shipment/form"
import { storeShipment } from "store/shipment/shipment-action"

const AddShipment = () => {
  document.title = "Add Shipment"
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error } = useSelector(state => state.shipment)

  return (
    <ShipmentForm
      onSubmit={values => dispatch(storeShipment(values, navigate))}
      loading={loading}
      error={error}
      formMode={"Add"}
    />
  )
}

export default AddShipment
